<div class="container-fluid">

  <h4 id="upper">Niveaux d'exécution physique du pta par direction</h4>
  <div class="d-flex justify-content-end">
    <div class="me-3">
      <label class="d-inline-flex align-items-center">
        Début:
        <input type="date" class="form-control ms-2" [(ngModel)]="dateDebut" name="dateDebut">
      </label>
    </div>

    <div class="me-3">
      <label class="d-inline-flex align-items-center">
        Fin:
        <input type="date" class="form-control ms-2" [(ngModel)]="dateFin" name="dateFin">
      </label>
    </div>

    <!-- Bouton Rechercher -->
    <div class="me-3">
      <div id="tickets-table_filter" class="dataTables_filter">
        <button (click)="getStatistiqueTepByDirection()" type="button" class="btn btn-primary"><i class="pi pi-search"
            style="font-size: 0.8rem"></i> Rechercher</button>
      </div>
    </div>
    <!-- Bouton Exporter -->
    <div class="dropdown d-inline-block mb-2" ngbDropdown>
      <button type="button" ngbDropdownToggle class="btn btn-secondary dropdown-toggle" id="dropdownMenuButton"
        aria-haspopup="true" aria-expanded="false">
        Exporter <i class="pi pi-upload" style="font-size: 0.8rem"></i>
      </button>
      <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu aria-labelledby="dropdownMenuButton">
        <a class="dropdown-item" href="javascript:void(0);" (click)="exportToDocument('pdf')">Au format PDF</a>
        <a class="dropdown-item" href="javascript:void(0);" (click)="exportToDocument('excel')">Au format Excel</a>
      </div>
    </div>

  </div>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">

          <div class="row">
            <div class="col-lg-12">
              <div class="table-responsive mt-3">
                <div class="table-responsive mt-3">
                  <table class="table table-centered datatable dt-responsive nowrap"
                    style="border-collapse: collapse; border-spacing: 0; width: 100%;">
                    <thead class="thead-light rwd-table">
                      <tr>
                        <th style="width: 20px;">
                          <!-- <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="customercheck" />
                        <label class="form-check-label" for="customercheck">&nbsp;</label>
                      </div> -->
                        </th>
                        <th>Direction</th>
                        <th>Tep Prévu (%)</th>
                        <th>Tep Réalisé (%)</th>
                        <th>Ecart</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of paginatedProjets; let index = index">
                        <td>

                        </td>

                        <td>{{item.direction?.libelle}}</td>
                        <td>{{item.tep_prevu}}</td>
                        <td>{{item.tep_realise}}</td>
                        <td>{{(item.tep_realise || 0) - (item.tep_prevu || 0) | number:'1.2-2'}}</td>

                        <td>
                          <a (click)="openModalActivitesParDirection(item)" style="cursor: pointer;"
                            class="me-3 text-primary" v-b-tooltip.hover title="détails">
                            <i class="pi pi-eye font-size-18"></i>
                          </a>
                        </td>
                      </tr>

                    </tbody>
                  </table>
                </div>
              </div>
              <div class="d-flex justify-content-center" *ngIf="isLoading === true">
                <div class="container">
                  <div class="row">
                    <div class="text-center">
                      <h5 id="graycolor">Chargement en cours</h5>
                      <div class="loader4"></div>
                    </div>
                  </div>
                </div>
              </div>
              <p-paginator (onPageChange)="onPageChangeProjets($event)" [first]="firstProjets" [rows]="rowsProjets"
                [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 30]">
              </p-paginator>
            </div>


          </div>

        </div>
      </div>
    </div>


  </div>


  <div class="card">
    <div class="row justify-content-center">

      <div class="col-md-6">
        <div class="card-body">

          <div *ngIf="items && items.length > 0; else noData">
            <p-chart type="bar" [data]="histogramData" [options]="chartOptions" height="400px" width="100%">
            </p-chart>
          </div>

          <ng-template #noData>
            <div class="text-center p-5">
              <i class="pi pi-chart-line" style="font-size: 3rem; color: #ccc;"></i>
              <p class="mt-3 text-muted">Aucune donnée disponible.</p>
            </div>
          </ng-template>

        </div>
      </div>

    </div>
  </div>
</div>

<p-dialog [(visible)]="displayModal" header="TEP {{ serviceLibelle }} ({{ptaItems.length}})" [modal]="true"
  [style]="{ width: '80vw' }" [closable]="true" (onHide)="closeModal()">
  <div class="p-fluid">

    <div class="d-flex justify-content-center" *ngIf="isLoadingModal === true">
      <div class="container">
        <div class="row">
          <div class="text-center">
            <h5 id="graycolor">Chargement en cours...</h5>
            <div class="loader4"></div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!isLoadingModal">
      <div class="mb-5">




        <table class="table table-bordered table-striped">
          <thead>
            <tr>
              <th>Code</th>
              <th>Libellé</th>
              <th>Poids</th>
              <th>TEP Prévu</th>
              <th>TEP Réalisé</th>
              <th>Ecart</th>
              <th style="width: 80px;"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let act of paginatedProjets1">
              <td>{{ act.activite.code_activite }}</td>
              <td>{{ act.activite.activite }}</td>
              <td>{{ act.activite.poids }}</td>
              <td>{{ act.tep_prevu }}</td>
              <td>{{ act.tep_realise }} </td>
              <td class="text-end">{{ (act.tep_realise - act.tep_prevu) }}</td>
              <td class="text-center">
                <a (click)="openModalTachesByDirection(act)" style="cursor: pointer;" class="me-3 text-primary" v-b-tooltip.hover title="détail tâches">
                  <i class="pi pi-eye font-size-18"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>

      </div>

      <div *ngIf="ptaItems.length === 0" class="text-center p-4">
        <p class="text-muted">Aucune donnée disponible</p>
      </div>

      <p-paginator *ngIf="totalRecords1 > 0" (onPageChange)="onPageChangeProjets1($event)" [first]="firstProjets1"
        [rows]="rowsProjets1" [totalRecords]="totalRecords1" [rowsPerPageOptions]="[10, 20, 30]">
      </p-paginator>
    </div>
  </div>
</p-dialog>

<!-- Modal détails des tâches par activité (Direction) -->
<p-dialog [(visible)]="displayModalTaches" header="Tâches de {{ activiteLibelle }} ({{tacheItems.length}})" [modal]="true"
  [style]="{ width: '80vw' }" [closable]="true" (onHide)="closeModalTaches()">
  <div class="p-fluid">
    <div class="d-flex justify-content-center" *ngIf="isLoadingModalTaches === true">
      <div class="container">
        <div class="row">
          <div class="text-center">
            <h5 id="graycolor">Chargement en cours...</h5>
            <div class="loader4"></div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!isLoadingModalTaches">
      <div class="mb-5">
        <table class="table table-bordered table-striped">
          <thead>
            <tr>
              <th>Code</th>
              <th>Libellé</th>
              <th>Poids</th>
              <th>TEP Prévu</th>
              <th>TEP Réalisé</th>
              <th>Ecart</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let tache of paginatedTaches">
              <td>{{ tache.code }}</td>
              <td>{{ tache.libelle }}</td>
              <td>{{ tache.poids }}</td>
              <td>{{ tache.tep_prevu }}</td>
              <td>{{ tache.tep_realise }}</td>
              <td class="text-end">{{ (tache.tep_realise - tache.tep_prevu) | number:'1.2-2' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div *ngIf="tacheItems.length === 0" class="text-center p-4">
        <p class="text-muted">Aucune donnée disponible</p>
      </div>
      <p-paginator *ngIf="totalRecordsTaches > 0" (onPageChange)="onPageChangeTaches($event)" [first]="firstTaches"
        [rows]="rowsTaches" [totalRecords]="totalRecordsTaches" [rowsPerPageOptions]="[10, 20, 30]">
      </p-paginator>
    </div>
  </div>
</p-dialog>

<p-confirmDialog />
<p-toast />
<ngx-ui-loader></ngx-ui-loader>